import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StatistikService } from '../../statistik.service';
import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { AuthSelectors, SessionSelectors } from '@store';
import { StatistikKunder } from '../../models/StatistikKunder';
import { StatistikKunderPlanNorm } from '../../models/StatistikKunderPlanNorm';

@Component({
    selector: 'app-statistik-kunder',
    template: `<app-statistik-kunder-ui
        [kaCards]="kaCards$ | async"
        [laCards]="laCards$ | async"
        [medarbejdere]="medarbejdere$ | async"
        [kunder]="kunder$ | async"
        [planNorm]="planNorm$ | async"
        [periode]="periode$ | async"
        [userId]="userId$ | async"
        (selectUser)="selectedUserIdSubject.next($event)"
        (periodeChange)="periodeSubject.next($event)"
        (reload)="reloadSubject.next()"
    ></app-statistik-kunder-ui>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikKunderContainerComponent {
    reloadSubject = new BehaviorSubject<void>(null);
    reload$ = this.reloadSubject.asObservable();
    selectedUserIdSubject = new BehaviorSubject<number>(null);
    selectedUserId$ = this.selectedUserIdSubject.asObservable();
    periodeSubject = new Subject<string>();
    periode$ = this.periodeSubject.asObservable();
    kunder$: Observable<StatistikKunder[]> = combineLatest([
        this.statistikService.visible$,
        this.statistikService.step$,
        this.periode$,
        this.reload$
    ]).pipe(
        filter(([visible, step]) => visible && step === 3),
        switchMap(([, , date]) => this.statistikService.getKunder(date))
    );
    planNorm$: Observable<StatistikKunderPlanNorm> = combineLatest([
        this.statistikService.visible$,
        this.statistikService.step$,
        this.periode$,
        this.selectedUserId$,
        this.reload$
    ]).pipe(
        filter(([visible, step]) => visible && step === 3),
        switchMap(([, , date, medId]) => this.statistikService.getKunderPlanNorm(date, medId))
    );
    laCards$ = this.periode$.pipe(switchMap(date => this.sessionSelector.usersLA$(new Date(date))));
    kaCards$ = this.periode$.pipe(switchMap(date => this.sessionSelector.usersKA$(new Date(date))));
    medarbejdere$ = this.periode$.pipe(switchMap(date => this.sessionSelector.users$(new Date(date))));
    userId$ = this.authSelector.userId$;

    constructor(
        private statistikService: StatistikService,
        private sessionSelector: SessionSelectors,
        private authSelector: AuthSelectors,
    ) { }
}
